import {
  Card,
  CardHeader,
  CardContent,
  CardDescription,
  CardTitle,
} from "@/components/ui/card";
import { logo } from "@/assets";
import { z } from "zod";
import FormInputField from "@/components/lib/from-input-field";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";

const loginSchema = z.object({
  username: z.string().min(1, "Username is required"),
  password: z.string().min(6, "Password must be at least 6 characters long"),
});

function AdminLogin() {
  const form = useForm({
    resolver: zodResolver(loginSchema),
    defaultValues: {
      username: "",
      password: "",
    },
  });

  const onSubmit = (data) => {
    console.log("Login data:", data);
  };

  return (
    <div className="bg-black h-screen w-screen flex justify-center items-center">
      <Card className=" bg-cblack2/80 max-w-screen-sm w-full">
        <CardHeader>
          <div className="flex flex-col gap-3 items-center justify-center">
            <img className="w-52" src={logo} alt="logo" />
            <div className="text-center space-y-1">
              <CardDescription>Welcome Back</CardDescription>
              <CardTitle className=" ">Login your account !</CardTitle>
              <CardDescription>
                Please enter your credentials below to continue
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent className="max-w-[500px] mx-auto">
          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(onSubmit)}
              className="flex flex-col gap-5"
            >
              <FormInputField
                name="username"
                style="bg-cblack7"
                placeholder={"Username"}
                form={form}
                type="text"
                label={"Username"}
              />
              <FormInputField
                name="password"
                style="bg-cblack7"
                placeholder={"Password"}
                form={form}
                type="password"
                label={"Password"}
              />
              <Button className="bg-cyellow w-full my-6">Log in</Button>
            </form>
          </Form>
        </CardContent>
      </Card>
    </div>
  );
}

export default AdminLogin;
